<template>
  <div class="wx-invite-landing">
    <!-- 顶部区域：230px，渐变背景，赛事 logo + 名称 + 组别，上下布局水平居中，间隔 12px -->
    <div class="match-title">
      <div class="match-title-inner">
        <div class="match-logo">
          <img :src="imgView(match.icon)" alt="" />
        </div>
        <div class="match-name">{{ match.chineseName || match.unionMatchName || '-' }}</div>
        <div class="match-group">{{ match.group || match.matchGroupName || '-' }}</div>
      </div>
    </div>
    <!-- 赛事下方：球队信息，白色背景 -->
    <div class="team-section">
      <div class="team-row">
        <div class="team-logo" v-if="team.badge">
          <img :src="imgView(team.badge)"  alt="" />
        </div>
        <span class="team-name">{{ team.name || '-' }}</span>
      </div>
      <div class="team-desc">邀请您填写资料，加入球队</div>
      <div
        class="btn-fill"
        :class="{ 'btn-fill--logged': isLoggedIn }"
        @click="justJoin"
      >
        {{ isLoggedIn ? '立即填写资料' : '登陆后填写资料' }}
      </div>
      <div v-if="officer && false" class="link-officer" @click="goOfficer">我是球队官员·立即注册</div>
    </div>
    <!-- 我的报名：仅登录且当前球队有报名数据时展示 -->
    <div v-if="isLoggedIn && mySignupList.length > 0" class="my-signup-section">
      <div class="my-signup-title">我的报名</div>
      <div class="my-signup-list">
        <div
          v-for="item in mySignupList"
          :key="item.playerId || item.id"
          class="my-signup-item"
          @click="goPlayerDetail(item)"
        >
          <div class="player-logo">
            <img :src="imgView(item.avatar)" v-if="item.avatar" alt="" />
            <img v-else src="@/assets/default-icon.png" alt="" />
          </div>
          <span class="player-name">{{ item.trueName || item.name || '-' }}</span>
          <span class="link-detail">查看详情</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as vanImage } from 'vant'
Vue.use(vanImage)
import { QNImageUtil, isWeChatMiniApp } from '@/utils'
import { getPassport } from '@/libs/passport'
import { getBMMatchTeamClaimDetail, getBMMatchTeamSignup, getMatchTeamListByUser } from '@/api/match'
import wx from 'weixin-js-sdk'
import { buildFullHashRedirectUrl } from '@/utils/redirect'

export default {
  data() {
    return {
      unionMatchId: '',
      teamId: '',
      matchId: '',
      team: {},
      match: {},
      officer: false,
      isLoggedIn: false,
      mySignupList: []
    }
  },
  mounted() {
    this.teamId = this.$route.query.teamId
    this.matchId = this.$route.query.matchId
    this.unionMatchId = this.$route.query.unionMatchId
    const params = {
      teamId: this.teamId,
      matchId: this.matchId
    }
    getPassport().then(res => {
      this.isLoggedIn = !!res
      this.maybeFetchMySignupList()
    })
    getBMMatchTeamSignup(params).then(res => {
      if (res) {
        const { data } = res
        this.match = data.match || {}
        const fs = this.match.teamSignupFields || ''
        this.officer = typeof fs === 'string' && fs.indexOf('officer') !== -1
      }
    })
    getBMMatchTeamClaimDetail(params).then(res => {
      if (res) {
        const { data } = res
        this.team = data.team || {}
        this.maybeFetchMySignupList()
      }
    })
  },
  methods: {
    imgView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    justJoin() {
      if (!this.isLoggedIn) {
        const redirect = `/entry-page/player-info?unionMatchId=${this.unionMatchId}&matchId=${this.matchId}&teamId=${this.teamId}&role=player`
        isWeChatMiniApp().then((isMini) => {
          if (isMini) {
            wx.miniProgram.navigateTo({ url: `/pages/common/login?redirect=${encodeURIComponent(buildFullHashRedirectUrl(redirect))}` })
          } else {
            this.$router.push({ path: '/auth/login', query: { redirect: encodeURIComponent(redirect) } })
          }
        })
        return
      }
      this.$router.push({
        path: '/entry-page/player-info',
        query: { unionMatchId: this.unionMatchId, matchId: this.matchId, teamId: this.teamId, role: 'player' }
      })
    },
    goOfficer() {
      this.$router.push({ path: '/entry-page/officer-form', query: { unionMatchId: this.unionMatchId, matchId: this.matchId, teamId: this.teamId } })
    },
    maybeFetchMySignupList() {
      if (!this.isLoggedIn || !this.unionMatchId || !this.team.id) return
      const tid = String(this.team.id)
      const mid = String(this.team.matchId)
      getMatchTeamListByUser({
        unionMatchId: this.unionMatchId,
        role: 0,
        orderIndex: 0
      }).then(res => {
        if (!res || !res.data) return
        const list = res.data.list || []
        this.mySignupList = list.filter(
          item => String(item.teamId) === tid && String(item.matchId) === mid
        )
      })
    },
    goPlayerDetail(item) {
      const teamId = this.team.id != null ? this.team.id : this.teamId
      const matchId = this.team.matchId != null ? this.team.matchId : this.matchId
      this.$router.push({
        path: '/entry-page/entry-info-player',
        query: {
          teamId,
          matchId,
          unionMatchId: this.unionMatchId,
          playerId: item.playerId,
          role: 'captain'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wx-invite-landing {
  min-height: 100vh;
  background-color: #F5F5F5;

  /* 顶部区域：230px，渐变，赛事 logo 62px + 名称 18px + 组别 16px，上下布局水平居中，间隔 12px */
  .match-title {
    height: 230px;
    background: linear-gradient(180deg, #DBEBFA 0%, #E8E4F0 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    .match-title-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 12px;
    }
    .match-logo {
      width: 62px;
      height: 62px;
      border-radius: 50%;
      overflow: hidden;
      background: #fff;
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .match-name {
      font-size: 18px;
      font-weight: 500;
      color: #1D2129;
      text-align: center;
    }
    .match-group {
      font-size: 16px;
      font-weight: 500;
      color: #1D2129;
      text-align: center;
    }
  }

  /* 赛事下方：球队信息，白色背景 */
  .team-section {
    background-color: #fff;
    padding: 24px 16px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .team-row {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: center;
      gap: 10px;
    }
    .team-logo {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      overflow: hidden;
      background: #e8e8e8;
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .team-name {
      font-size: 17px;
      font-weight: 500;
      color: #303133;
    }
    .team-desc {
      margin-top: 12px;
      font-size: 16px;
      font-weight: 500;
      color: #1D2129;
      text-align: center;
    }
    .btn-fill {
      width: 303px;
      height: 54px;
      border-radius: 82px;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      background: #30D55B;
      border: none;
      &.btn-fill--logged {
        background: var(--bg3);
      }
    }
    .link-officer {
      margin-top: 18px;
      font-size: 16px;
      font-weight: 500;
      color: #4AA2F7;
      text-align: center;
    }
  }

  /* 我的报名 */
  .my-signup-section {
    background: #fff;
    margin-top: 12px;
    padding: 16px;
    .my-signup-title {
      font-size: 16px;
      font-weight: bold;
      color: #1D2129;
      margin-bottom: 12px;
    }
    .my-signup-list {
      .my-signup-item {
        display: flex;
        align-items: center;
        padding: 12px 0;
        border-bottom: 1px solid #F2F3F5;
        &:last-child {
          border-bottom: none;
        }
        .player-logo {
          width: 54px;
          height: 54px;
          border-radius: 50%;
          overflow: hidden;
          background: #e8e8e8;
          flex-shrink: 0;
          margin-right: 12px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .player-name {
          flex: 1;
          min-width: 0;
          font-size: 15px;
          font-weight: 500;
          color: #1D2129;
        }
        .link-detail {
          flex-shrink: 0;
          font-size: 14px;
          font-weight: 500;
          color: var(--bg3);
        }
      }
    }
  }
}
</style>
